export const permissionInfoMock = { userRoles: ['ADMIN'] };

export const props = {
  userRoles: permissionInfoMock.userRoles,
};
